import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import OcurrencesWrapper from './Ocurrences';
import PeriodWrapper from './Period';
import ProfileWrapper from './Profile';
import SectorizationWrapper from './Sectorization';
import SpecialCareWrapper from './SpecialCare';



const Results = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Ocorrências',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Periodicidade',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/period`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Perfil',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/profile`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Setorização',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/sectorization`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Cuidados Especiais',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/special-care`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`]:
            'Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/period`]:
            'Periodicidade das Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/profile`]:
            'Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/sectorization`]:
            'Setorização das Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/special-care`]:
            'Cuidados Especiais'
    };

    const subtitleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/period`]:
            'Temporalidade das Ocorrências'
    }

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    subtitle={subtitleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="ocurrences" replace />}
                        />
                        <Route
                            path="period"
                            element={<PeriodWrapper />}
                        />
                        <Route
                            path="ocurrences"
                            element={<OcurrencesWrapper />}
                        />
                        <Route
                            path="profile"
                            element={<ProfileWrapper />}
                        />
                        <Route
                            path="sectorization"
                            element={<SectorizationWrapper />}
                        />
                        <Route
                            path="special-care"
                            element={<SpecialCareWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Results;
